import { pipe } from 'fp-ts/lib/function';
import { failure, parse, struct, success } from 'io-ts/lib/Decoder';

import { iotsUtils } from '@bedc/core';

import { UnsafeTimezone } from './timezone';

export const Datetime = struct({
	/** ISO-8601 datetime value, e.g. YYYY-MM-DDTHH:MM:SS[.SSS][Z|±HH:MM] */
	timestamp: pipe(
		iotsUtils.ValidDate,
		parse((s) => {
			// Required date + time, with optional milliseconds and an optional
			// timezone designator (Z or ±HH:MM).
			if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?$/.test(s)) {
				return success(s);
			}

			return failure(s, 'valid datetime');
		})
	),
	/** The timezone of the epoch */
	timezone: UnsafeTimezone,
});
